import { Component } from '@angular/core';
import {DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";
import {CompoMagazzino} from "../anagrafica-magazzini.component";
import {Impresa} from "../../../../models/impresa.model";
import {RegioneDTO} from "../../../../models/regione.model";
import {MessageService, SelectItem} from "primeng/api";
import {MagazzinoApiDescriptor} from "../../../../models/magazzino.model";

@Component({
  selector: 'app-magazzino-edit-create-dialog',
  templateUrl: './magazzino-edit-create-dialog.component.html',
  styleUrls: ['./magazzino-edit-create-dialog.component.scss']
})
export class MagazzinoEditCreateDialogComponent {

	hasValidForm: boolean;
	modeCreate: boolean;

	edits: MagazzinoApiDescriptor;

	optionsRegioni: SelectItem<number>[];
	optionsAziende: SelectItem<number>[];

	constructor(
		public ref: DynamicDialogRef,
		public config: DynamicDialogConfig<{
			src: CompoMagazzino,
			imprese: Impresa[],
			regioni: RegioneDTO[]
		}>,
		private messages: MessageService
	) {

		this.modeCreate = config.data.src == null;

		this.optionsAziende = config.data.imprese.map((item) => {
			return {
				label: item.ragioneSociale,
				value: item.id
			}
		});

		this.optionsRegioni = config.data.regioni.map((item) => {
			return {
				label: item.denominazione,
				value: item.id
			}
		});

		this.edits = this.createEditableItem(config.data.src);
		this.verifyEditsValidity();

		console.log(this.config.data, this.optionsRegioni, this.optionsAziende);
	}

	createEditableItem (src?: CompoMagazzino): MagazzinoApiDescriptor {
		return {
			id: src?.id ?? null,
			codice: src?.codice ?? "",
			azienda: src?.azienda.id ?? null,
			regioni: src?.regioni.map((item) => item.id) ?? [],
			indirizzo: src?.indirizzo ?? "",
			referente: src?.referente ?? "",
		}
	}

	verifyEditsValidity () {
		this.hasValidForm = this.edits.azienda != null && this.edits.codice.length >= 3;
	}

	onActivityCompleted (confirm: boolean) {
		this.ref.close(confirm ? this.edits : null);
	}


}
